<template>
  <div :ref="ref" :id="ref" :style="{ width: width + 'px' }" />
</template>

<script>
import E from "wangeditor";
import OSS from "ali-oss";
import config from "@assets/config.json";
export default {
  name: "Editor",
  props: {
    value: "",
    width: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {
      uploadUrl: `${config.api.reqApi3}/api/upload/files`,
      ref: new Date().getTime(),
      client: null,
      editor: null,
    };
  },
  watch: {
    value(val) {
      console.log(val);
    },
  },
  mounted() {
    this.client = new OSS(config.oss);
    this.init();
  },
  methods: {
    init() {
      console.log(this.uploadUrl);
      const that = this;
      this.editor = new E(this.$refs[this.ref]);
      console.log("this.ref", this.ref, this.editor);
      this.editor.txt.clear();
      this.editor.config.onchange = (text) => {
        console.log("input", text);
        that.$emit("input", text);
      };
      this.editor.config.uploadImgServer = "图片上传地址";
      this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
      this.editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.config.uploadImgMaxLength = 1; // 限制一次最多上传 1 张图片
      this.editor.config.showLinkImg = false; // 隐藏网络图片上传

      this.editor.config.customUploadImg = function (files, insert) {
        console.log('files', files[0])
        const file = files[0]
        const str = file.name.substring(
          file.name.lastIndexOf('.') + 1,
          file.name.length
        )
        const storeAs = that.fileName(str, 'file')
        // 上传文件,这里是上传到OSS的 uploads文件夹下


        // that.client.put(storeAs, file).then((res) => {
        //   if (res.res.statusCode === 200) {
        //     res.imgUrl = config.staticUrl + '/' + res.name
        //     insert(res.imgUrl) // 插入地址
        //   }
        // })

          let obsClient = new ObsClient({
            access_key_id:  config.obs.access_key_id,
            secret_access_key: config.obs.secret_access_key,
            server:  config.obs.server,
        });

              obsClient.putObject(
          {
            Bucket:  config.obs.bucket,
            Key: storeAs, // 存储在obs的文件。可写成file/name即会生成file文件夹name文件
            SourceFile: file, // 文件上传使用sourceFile文本上传采用Body
          },
          function (err, result) {
            if (err) {
              console.error("Error-->", err);
              that.$Message.warning("上传失败，请重新尝试！");
            } else {
              const url = config.obs.url + storeAs;
                     result.imgUrl = url
            insert(result.imgUrl) // 插入地址
                console.log(url);
            }
          }
        );




      }
      this.editor.zIndex.baseZIndex = 8; //方法
      this.editor.create();
      this.editor.txt.html(this.value);
    },
    fileName(str, type) {
      const year = new Date().getFullYear();
      var month = new Date().getMonth();
      const time = new Date().getTime();
      if (month < 9) {
        month = "0" + (month + 1);
      } else {
        month = month + 1;
      }
      const prefix = `/${config.oss.bucket}/${type}`; // 文件前缀
      // 返回随机数 n是取值几位数
      let res = "";
      for (; res.length < 5; res += Math.random().toString(36).substr(2).toUpperCase()) {}
      const random = res.substr(0, 5);
      const name = `${prefix}/${year}${month}/${time}${random}.${str}`;
      return name.toLocaleLowerCase();
    },
    setInitData(val) {
      // 设置值
      this.editor.txt.html(val);
    },
  },
};
</script>
<style scoped></style>
